$(document).on('change', '.autosubmit', function (){
    filterProducts($(this).attr('name'), $(this).val());
});

$(document).on('change', '.autosubmit-check', function (){
    let value = 0;
    if($(this).is(":checked")) {
        value = 1;
    }
    filterProducts($(this).attr('name'), value);
});

$('input[type="number"].autosubmit').on('input', function() {
    clearTimeout($.data(this, 'timeeeeer'));
    $.data(this, 'timeeeeer', setTimeout(() => $(this).trigger('stopWriting'), 350));
});

$('input[type="number"].autosubmit').on('stopWriting', function() {
    filterProducts($(this).attr('name'), $(this).val());
});


$(document).on('click', '.pager-href', function (e){
    e.preventDefault();
    filterProducts('activePage', $(this).data('value'));
    $('html, body').animate({
        scrollTop: $("#category-name").offset().top
    }, 700);
});

function filterProducts(name, value){
    let filterData = $(document).find("#filter-data");
    let formData = {};

    formData.filter = filterData.data('filter');
    formData.name = name;
    formData.value = value;

    $.nette.ajax({
        url: filterData.data("url"),
        data: formData,
        type: 'POST',
        //processData: false,
        //contentType: false,
        off: {
            snippets: true
        },
        success: function (payload) {
            if(payload.filter){
                window.history.pushState("", "", ABSOLUTE_URL + "?activeFilter=" + (payload.filter));
            }
            new LazyLoad({
                elements_selector: ".lazy-image" // Specifikuj selektor dynamických lazy-load obrázků
            });

        },
        error: function (err) {

        }
    });
}
